import React from 'react'
import classnames from 'classnames'
import {
  ComponentSize,
  ComponentColor,
  ButtonShape,
  ComponentStatus,
} from '@influxdata/clockface'

interface Props {
  url: string
  text: string
  openTab: boolean
  size?: ComponentSize
  color?: ComponentColor
  shape?: ButtonShape
  className: string
  onClick: () => void
  active?: boolean
}

const LinkButton = ({
  url,
  text,
  openTab,
  size = ComponentSize.Small,
  color = ComponentColor.Default,
  shape = ButtonShape.Default,
  active = false,
  onClick,
  className,
}: Props): JSX.Element => {
  const target = openTab ? '_blank' : ''

  const buttonBaseClass = classnames(
    `cf-button cf-button-${size} cf-button-${color}`,
    {
      'cf-button-square': shape === ButtonShape.Square,
      'cf-button-stretch': shape === ButtonShape.StretchToFit,
      'cf-button--loading': status === ComponentStatus.Loading,
      'cf-button--disabled': status === ComponentStatus.Disabled,
      active,
      [`${className}`]: className,
    }
  )

  return (
    <div className="plan-card--button-section">
      <a
        href={url}
        target={target}
        className={buttonBaseClass}
        onClick={onClick}
      >
        {text}
      </a>
    </div>
  )
}

export default LinkButton
